import notificationsService from '@/services/notificationsService'

const state = {
  notifications: [],
  loadingNotification: false,
  loadingNotifications: true,
  paginationNotifications: {
    page: 1,
    limit: 50
  },
  totalNotifications: 0,
  selectedNotification: {}
}

const mutations = {
  'SET_TOTAL_NOTIFICATIONS' (state, totalNotifications) {
    state.totalNotifications = totalNotifications
  },
  'SET_NOTIFICATIONS' (state, notifications) {
    state.notifications = notifications
  },
  'SET_LOADING_NOTIFICATION' (state, status) {
    state.loadingNotification = status
  },
  'SET_LOADING_NOTIFICATIONS' (state, status) {
    state.loadingNotifications = status
  },
  'SET_PAGINATION_NOTIFICATIONS' (state, pagination) {
    state.paginationNotifications = pagination
  },
  'SET_SELECTED_NOTIFICATION' (state, notification) {
    state.selectedNotification = notification
  }
}

const actions = {
  createNotification (vuexContext, { name, code }) {
    return new Promise((resolve, reject) => {
      notificationsService.createNotification(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        { name, code })
        .then(() => {
          vuexContext.dispatch('getNotifications')
          resolve(true)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getNotifications (vuexContext) {
    vuexContext.commit('SET_LOADING_NOTIFICATIONS', true)
    notificationsService.getNotifications(vuexContext.getters.token, vuexContext.getters.companyUuid, vuexContext.getters.appUuid, vuexContext.state.paginationNotifications)
      .then(response => {
        vuexContext.commit('SET_TOTAL_NOTIFICATIONS', response.notifications.count)
        vuexContext.commit('SET_NOTIFICATIONS', response.notifications.rows)
        vuexContext.commit('SET_LOADING_NOTIFICATIONS', false)
      })
      .catch((error) => {
        console.log(error)
        vuexContext.commit('SET_NOTIFICATIONS', [])
        vuexContext.commit('SET_LOADING_NOTIFICATIONS', false)
      })
  },
  updateNotification (vuexContext, { notificationId, name, code }) {
    return new Promise((resolve, reject) => {
      notificationsService.updateNotification(
        vuexContext.getters.token,
        vuexContext.getters.companyUuid,
        vuexContext.getters.appUuid,
        notificationId,
        { name, code })
        .then(() => {
          vuexContext.dispatch('getNotifications')
          resolve(true)
        })
    })
  }
}

const getters = {
  totalNotifications (state) {
    return state.totalNotifications
  },
  notificationCode (state) {
    return state.selectedNotification.code
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
